import React from 'react';

import { useKeycloak } from '@react-keycloak/web';
import { Navigate, Route, Routes } from 'react-router-dom';

import DataGrid from './components/dataGrid/DataGrid';
import CompareLayout from './components/layout/CompareLayout';
import DraftLayout from './components/layout/DraftLayout';
import Layout from './components/layout/layout';
import ContractComponent from './Pages/Contracts/ContractComponent';
import Drafts from './Pages/Drafts';
import CompareDraft from './Pages/Drafts/CompareDraft';
import ViewDraft from './Pages/Drafts/ViewDraft';

function Root() {
  const { keycloak } = useKeycloak();
  const isLoggedIn = keycloak.authenticated;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="dictionary" element={<ContractComponent />} />
        <Route path="dictionary/:id" element={<DataGrid />} />
        <Route path="drafts" element={<Drafts />} />
        {isLoggedIn && (
          <Route path="/" element={<Navigate replace to="/drafts" />} />
        )}
      </Route>
      <Route path="drafts" element={<DraftLayout />}>
        <Route path="view-draft/:id" element={<ViewDraft />} />
      </Route>
      <Route path="compare" element={<CompareLayout />}>
        <Route path="drafts/:id" element={<CompareDraft />} />
      </Route>
    </Routes>
  );
}

export default Root;
